import { Component, OnDestroy } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IXVIHeaderParams } from '@shared/types';
import { debounce, isFunction } from 'lodash';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-header-icon-renderer',
  templateUrl: './header-icon-renderer.component.html',
  styleUrls: ['./header-icon-renderer.component.scss'],
})
export class XVIHeaderIconRendererComponent
  implements IHeaderAngularComp, OnDestroy
{
  public params!: IXVIHeaderParams;
  public unsorted: boolean;
  public ascSort: boolean;
  public descSort: boolean;
  public isColumnSortable: boolean = false;

  public agInit(params: IHeaderParams): void {
    this.params = params;
    this.isColumnSortable = params.enableSorting ?? false;
    params.column.addEventListener(
      'sortChanged',
      debounce(this.onSortChanged, 0, { leading: true }),
    );

    this.onSortChanged();
  }

  public onClick(): void {
    if (isFunction(this.params.headerIconClick)) {
      this.params?.headerIconClick();
    }
  }

  public onSortChanged = (): void => {
    this.ascSort = this.params.column.isSortAscending();
    this.descSort = this.params.column.isSortDescending();
    this.unsorted = !this.ascSort && !this.descSort;
  };

  public progressSort(): void {
    if (this.isColumnSortable) {
      if (!this.ascSort && !this.descSort) {
        this.params.setSort(null);
      }
      this.params.progressSort(true);
    }
  }

  public ngOnDestroy(): void {
    if (isFunction(this.params?.column?.removeEventListener)) {
      this.params.column.removeEventListener('sortChanged', this.onSortChanged);
    }
  }
}
